import React from "react";

import { Case, Switch } from "@/components/switch";

import FlowMode from "@/models/enums/flow-mode.ts";
import MeasureCard2D from "./measure-card-2d.tsx";
import MeasureCard3D from "./measure-card-3d.tsx";
import Tooltip from "@/components/tooltip";

interface MeasureCardsProps {
    flowMode: FlowMode;
    onRegisterFileSelect?: (handler: (files: FileList | null) => void) => void;
}

const MeasureCards: React.FC<MeasureCardsProps> = ({ flowMode, onRegisterFileSelect }) => (
        <>
            <Tooltip id='organisation-tooltip' />
            <div className='min-h-40 max-w-120 max-h-full overflow-y-auto'>
                <Switch value={flowMode}>
                    <Case value={FlowMode._2D3D}>
                        <MeasureCard2D onRegisterFileSelect={onRegisterFileSelect} />
                    </Case>

                    <Case value={[FlowMode._3D2D, FlowMode._2D3DAdvanced]}>
                        <MeasureCard3D />
                    </Case>
                </Switch>
            </div>
        </>
    );

export default MeasureCards;